import React from "react"
import { Link } from "react-router-dom"
import Footer from "../components/footer"
import Navbar from "../components/nav"
function Fpl() {
  return (
    <>
      <header className="header-area">
        <div className="navbar-area">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <Navbar />
              </div>
            </div>
          </div>
        </div>
        <div id="home" className="header-hero bg_cover d-lg-flex align-items-center">
          <div className="shape shape-1" />
          <div className="shape shape-2" />
          <div className="shape shape-3" />
          <div className="shape shape-4" />
          <div className="shape shape-5" />
          <div className="shape shape-6" />
          <div className="container">
            <div className="row align-items-center justify-content-center justify-content-lg-between">
              <div className="col-lg-6 col-md-10">
                <div className="header-hero-content">
                  <h3
                    className="header-title wow fadeInLeftBig"
                    data-wow-duration="1.3s"
                    data-wow-delay="0.2s"
                  >
                    <span>FPL CS:GO</span> & Faceit Stats
                  </h3>
                  <p
                    className="text wow fadeInLeftBig"
                    data-wow-duration="1.3s"
                    data-wow-delay="0.6s"
                  >
                    FPL CS: GO & Faceit Stats Application is designed for you to
                    easily follow Faceit CS: GO Pro Leagues and CS: GO statistics on
                    mobile. In this App, you can follow the Dates of FPL Leagues,
                    Current FPL CSGO Rankings, Statistics of Played Matches and Live
                    Streams. You can also find out your own statistics and elo.
                  </p>
                  <ul className="d-flex">
                    <li>
                      <a
                        href="https://play.google.com/store/apps/details?id=com.fplrankings.faceitproleague"
                        target="_blank"
                        rel="nofollow"
                        className="main-btn wow fadeInLeftBig"
                        data-wow-duration="1.3s"
                        data-wow-delay="0.8s"
                      >
                        <img src="assets/images/play-store.png" alt="playstore" />
                      </a>
                    </li>
                  </ul>
                  <div className="mt-4 wow fadeInLeftBig" data-wow-duration="1.3s" data-wow-delay="0.9s">
                    <Link to="/faceit-pro-league/privacy-policy" className="mr-4" style={{ color: "#0898e7", fontWeight: "600" }}>
                      Privacy Policy
                    </Link>
                    <Link to="/faceit-pro-league/terms-and-conditions" style={{ color: "#0898e7", fontWeight: "600" }}>
                      Terms & Conditions
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-6 col-10">
                <div className="header-image">
                  <img src="assets/images/2.png" alt="app" className="image" />
                </div>
              </div>
            </div>
          </div>
          <div className="header-shape-1" />
          <div className="header-shape-2">
            <img src="assets/images/header-shape-2.svg" alt="shape" />
          </div>
        </div>
      </header>
      <Footer />
    </>
  )
}

export default Fpl
